module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "condition-container"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParams
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入设备编号"
    },
    model: {
      value: (_vm.queryParams.clientUsername),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "clientUsername", $$v)
      },
      expression: "queryParams.clientUsername"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入订单编号"
    },
    model: {
      value: (_vm.queryParams.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderNo", $$v)
      },
      expression: "queryParams.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.$dateQuickPickerOptions
    },
    model: {
      value: (_vm.rangeTime),
      callback: function($$v) {
        _vm.rangeTime = $$v
      },
      expression: "rangeTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.query(1)
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "data-container"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "border": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  }, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "imei",
      "label": "设备编号(SN)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打印诉求",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.delay == 0) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("立即打印")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("延迟" + _vm._s(scope.row.delay) + "分钟打印")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "回调需求",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.needCallback == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("需要")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("不需要")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "打印内容",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "detail",
          on: {
            "click": function($event) {
              return _vm.detail(scope.row)
            }
          }
        }, [_vm._v("点击查看")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "任务状态",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("已取消")]) : (!scope.row.printResult) ? _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("待处理")]) : (scope.row.printResult == 1) ? _c('el-tag', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v("已下发")]) : (scope.row.printResult == 2) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("已接收")]) : (scope.row.printResult == 3) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("已完成")]) : (scope.row.printResult == 4 || scope.row.printResult == 5) ? _c('el-tag', {
          attrs: {
            "type": "warning"
          }
        }, [_vm._v("待重推\n                    ")]) : _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("其他")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "completeTime",
      "label": "完成时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "costTime",
      "label": "耗时(s)",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "148"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.reprint(scope.row.id)
            }
          }
        }, [_vm._v("重打\n                    ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "disabled": scope.row.status == 1 || scope.row.printResult == 3
          },
          on: {
            "click": function($event) {
              return _vm.setComplete(scope.row)
            }
          }
        }, [_vm._v("取消\n                    ")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "paging-container paging"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-sizes": _vm.$pageSizes,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "打印内容",
      "visible": _vm.detailVisible,
      "close-on-click-modal": false,
      "width": "640px"
    },
    on: {
      "update:visible": function($event) {
        _vm.detailVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "task-content"
  }, [_vm._v(_vm._s(_vm.taskContent))]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "id": "copy",
      "data-clipboard-text": _vm.taskContent
    }
  }, [_vm._v("复 制")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.detailVisible = false
      }
    }
  }, [_vm._v("关 闭")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fd68b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/printRecord.vue
// module id = 340
// module chunks = 1